/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryTree} from '../models/DictionaryTree';
import type {Error} from '../models/Error';

export interface GetSupportedNewsletterTypes$Request {
    featureForce: boolean;
    userId?: number;
}

export interface GetSupportedNewsletterTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedNewsletterTypesRequest = createAction<PayloadData<void, GetSupportedNewsletterTypes$Request>>('NEWSLETTER_DICTIONARY__GET_SUPPORTED_NEWSLETTER_TYPES__REQUEST');
export const getSupportedNewsletterTypesSuccess = createAction<PayloadData<Array<DictionaryTree>, GetSupportedNewsletterTypes$Request>>('NEWSLETTER_DICTIONARY__GET_SUPPORTED_NEWSLETTER_TYPES__SUCCESS');
export const getSupportedNewsletterTypesFailure = createAction<PayloadData<Error, GetSupportedNewsletterTypes$Request, true>>('NEWSLETTER_DICTIONARY__GET_SUPPORTED_NEWSLETTER_TYPES__FAILURE');

export const getSupportedNewsletterTypesActions = [
    getSupportedNewsletterTypesRequest,
    getSupportedNewsletterTypesSuccess,
    getSupportedNewsletterTypesFailure
] as const;

/**
 * @param {boolean} meta.featureForce
 * @param {number} [meta.userId] Id of the user to get supported newsletter types for.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedNewsletterTypes = (meta: GetSupportedNewsletterTypes$Request, config?: GetSupportedNewsletterTypes$Config) => {
    const TRANSPORT_GET_PARAMS = {
        userId: meta.userId,
        featureForce: meta.featureForce,
    };
    return {
        CALL_API: {
            types: getSupportedNewsletterTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/newsletter-types`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

